// export const ROUTES_NOT_SHOW_CONFIRM = {
//   ESTATE: {
//     EDIT: 'Estate Edit',
//     CONFIRM: 'Estate Confirm',
//     CREATE_TERM: 'EstateCreateTerm',
//     CREATE_CATEGORY: 'EstateCategory',
//     CREATE_ADDRESS: 'EstateAddress',
//     CREATE_DETAIL_INFO: 'EstateDetailInfo',
//     CREATE_INFO_CONFIRM: 'EstateInfoConfirm',
//     CREATE_COMPLETE: 'EstateCreateComplete',
//   },
// };
export const ROUTES_NOT_SHOW_CONFIRM = {
  ESTATE_EDIT: 'estate-edit',
  REGISTER: 'register',
  ESTATE_CREATE: 'estate-create',
  DESTINATION: 'destination',
  RE_EXHIBIT: 're_exhibit',
};

export const ROUTE_SEARCH_BY_TRAIN_LINE = '/search/by-train-line';
export const ROUTE_SEARCH_RESULT = '/search/result';
